import { filterByHairGrowthType } from "../../src/helpers/filters";

// vertical slug constants
export const COFFEE_CLUBS_PATH = "coffee-clubs";
export const PET_FOOD_DELIVERY_PATH = "pet-food-delivery";
export const WINE_CLUBS_PATH = "wine-clubs";
export const MEAT_DELIVERY_SERVICES_PATH = "meat-delivery-services";
export const INCORPORATION_SERVICES_PATH = "incorporation-services";
export const MATTRESSES_PATH = "mattresses";
export const SURVEY_SITES_PATH = "survey-sites";
export const SOLAR_PATH = "solar";
export const BUSINESS_VPN_PATH = "business-vpn";
export const PERSONAL_VPN_PATH = "personal-vpn";
export const MATTRESS_TOPPERS_PATH = "mattress-toppers";
export const ELECTRONIC_SIGNATURE_PATH = "electronic-signature";
export const PROMOTIONAL_PRODUCTS_PATH = "promotional-products";
export const ACCOUNTS_PAYABLE_PATH = "accounts-payable";
export const BUSINESS_PASSWORD_MANAGERS_PATH = "business-password-managers";
export const GLOBAL_HR_PATH = "global-hr";
export const WEBSITE_BUILDERS_PATH = "website-builders";
export const TEA_CLUBS_PATH = "tea-clubs";
export const PDF_EDITORS_PATH = "pdf-editors";
export const BACKGROUND_SEARCH_PATH = "background-search";
export const LANGUAGE_LEARNING_PATH = "language-learning";
export const DIET_MEAL_PLANS_PATH = "diet-meal-plans";
export const MEAL_DELIVERY_PATH = "meal-delivery";
export const DNA_TESTING_PATH = "dna-testing";
export const ELECTRIC_BIKES_PATH = "electric-bikes";
export const FLOWER_DELIVERY_PATH = "flower-delivery";
export const CELL_PHONE_PLANS_PATH = "cell-phone-plans";
export const INVISIBLE_BRACES_PATH = "invisible-braces";
export const HAIR_GROWTH_PATH = "hair-growth";
export const TEETH_WHITENING_PATH = "teeth-whitening";
export const WEIGHT_LOSS_PATH = "weight-loss";
export const MUSHROOM_COFFEE_PATH = "mushroom-coffee";

/* URL filter parameters */
export const GENDER_WOMEN_HAIR_GROWTH_URL_PARAMETER = "women";
export const GENDER_MEN_HAIR_GROWTH_URL_PARAMETER = "men";

/* Also constants for filtering UI, specifically filtering keys*/
export const HAIR_GROWTH_FILTERING_KEY = "gender";

export const FAVY_SITE_CONFIGURATION = {
	[COFFEE_CLUBS_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[MUSHROOM_COFFEE_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[PET_FOOD_DELIVERY_PATH]: {
		companyListHeaderParts: [
			"#",
			"Service",
			"Offerings",
			"Human Grade?",
			"Free Shipping?",
		],
		serviceRightColumns: [
			{ fields: "offerings", label: "Offerings" },
			{ fields: "humanGradeIngredients", label: "Human-grade Ingredients?" },
			{ fields: "freeShipping", label: "Free Shipping?" },
		],
	},
	[WINE_CLUBS_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[MEAT_DELIVERY_SERVICES_PATH]: {
		companyListHeaderParts: [
			"#",
			"Service",
			"Offerings",
			"Ordering Options",
			"Free Shipping?",
		],
		serviceRightColumns: [
			{ fields: "offerings", label: "Offerings" },
			{ fields: "orderingOptions", label: "Ordering Options" },
			{ fields: "freeShipping", label: "Free Shipping?" },
		],
	},
	[INCORPORATION_SERVICES_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[MATTRESSES_PATH]: {
		companyListHeaderParts: [
			"#",
			"Mattress Company",
			"Year Founded",
			"Trial Period",
		],
		serviceRightColumns: [
			{ fields: "yearFounded", label: "Year Founded" },
			{ fields: "trialPeriod", label: "Trial Period" },
		],
	},
	[SURVEY_SITES_PATH]: {
		companyListHeaderParts: [
			"#",
			"Site",
			"Year Founded",
			"BBB Rating",
			"Payout",
		],
		serviceRightColumns: [
			{ fields: "yearFounded", label: "Year Founded" },
			{ fields: "bbbRating", label: "BBB Rating" },
			{ fields: "payout", label: "Payout" },
		],
	},
	[SOLAR_PATH]: {
		companyListHeaderParts: ["#", "Company", "Year Founded", "BBB Rating"],
		serviceRightColumns: [
			{ fields: "yearFounded", label: "Year Founded" },
			{ fields: "bbbRating", label: "BBB Rating" },
		],
	},
	[BUSINESS_VPN_PATH]: {
		preventRenderingCompanyListHeader: true,
		serviceRightColumns: [
			{ fields: "yearFounded", label: "Year Founded" },
			{ fields: "pricing", label: "Starting Price (monthly)" },
			{ fields: "minimumUsers", label: "Minimum Users" },
		],
	},
	[PERSONAL_VPN_PATH]: {
		preventRenderingCompanyListHeader: true,
		serviceRightColumns: [
			{ fields: "pricing", label: "Starting Price (monthly)" },
			{ fields: "entertainment", label: "Entertainment" },
			{ fields: "privacy", label: "Privacy" },
		],
	},
	[MATTRESS_TOPPERS_PATH]: {
		companyListHeaderParts: ["#", "Company", "Year Founded", "Trial Period"],
		serviceRightColumns: [
			{ fields: "yearFounded", label: "Year Founded" },
			{ fields: "trialPeriod", label: "Trial Period" },
		],
	},
	[ELECTRONIC_SIGNATURE_PATH]: {
		preventRenderingCompanyListHeader: true,
		serviceRightColumns: [
			{ fields: "trialPeriod", label: "Trial Period" },
			{ fields: "pricing", label: "Starting Price" },
			{ fields: "greatFor", label: "Great For" },
		],
	},
	[PROMOTIONAL_PRODUCTS_PATH]: {
		companyListHeaderParts: [
			"#",
			"Company",
			"Year Founded",
			"Bulk Discounts",
			"Free Samples",
		],
		serviceRightColumns: [
			{ fields: "yearFounded", label: "Year Founded" },
			{ fields: "bulkDiscounts", label: "Bulk Discounts" },
			{ fields: "freeSamples", label: "Free Samples" },
		],
	},
	[ACCOUNTS_PAYABLE_PATH]: {
		preventRenderingCompanyListHeader: true,
		serviceRightColumns: [
			{ fields: "yearFounded", label: "Year Founded" },
			{ fields: "bbbRating", label: "BBB Rating" },
			{ fields: "greatFor", label: "Great For" },
		],
	},
	[BUSINESS_PASSWORD_MANAGERS_PATH]: {
		preventRenderingCompanyListHeader: true,
		serviceRightColumns: [
			{ fields: "yearFounded", label: "Year Founded" },
			{ fields: "pricing", label: "Starting Price (monthly)" },
			{ fields: "minimumUsers", label: "Minimum Users" },
		],
	},
	[GLOBAL_HR_PATH]: {
		preventRenderingCompanyListHeader: true,
		serviceRightColumns: [
			{ fields: "yearFounded", label: "Year Founded" },
			{ fields: "greatFor", label: "Great For" },
		],
	},
	[WEBSITE_BUILDERS_PATH]: {
		preventRenderingCompanyListHeader: true,
		serviceRightColumns: [
			{ fields: "freeTrial", label: "Free Trial?" },
			{ fields: "pricing", label: "Starting Price (monthly)" },
			{ fields: "freeDomain", label: "Free Domain?" },
		],
	},
	[TEA_CLUBS_PATH]: {
		companyListHeaderParts: [
			"#",
			"Club",
			"Pricing",
			"Total Cups",
			"Specialty Grade?",
		],
		serviceRightColumns: [
			{
				fields: "pricing",
				label: "Pricing",
				formatter: (pricing) => `$${pricing}`,
			},
			{ fields: "totalCups", label: "Total Cups" },
			{ fields: "specialtyGrade", label: "Specialty Grade?" },
		],
	},
	[PDF_EDITORS_PATH]: {
		preventRenderingCompanyListHeader: true,
		serviceRightColumns: [
			{
				fields: "pricing",
				label: "Annual Pricing",
				formatter: (pricing) => `$${pricing}`,
			},
			{ fields: "usersPerAccount", label: "Users Per Account" },
			{ fields: "freeVersion", label: "Free Version?" },
		],
	},
	[BACKGROUND_SEARCH_PATH]: {
		showFeaturedCompany: true,
		preventRenderingCompanyListHeader: true,
	},
	[LANGUAGE_LEARNING_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[DIET_MEAL_PLANS_PATH]: {
		preventRenderingCompanyListHeader: true,
	},
	[MEAL_DELIVERY_PATH]: {
		preventRenderingCompanyListHeader: true,
	},
	[DNA_TESTING_PATH]: {
		preventRenderingCompanyListHeader: true,
	},
	[ELECTRIC_BIKES_PATH]: {
		preventRenderingCompanyListHeader: true,
	},
	[FLOWER_DELIVERY_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[CELL_PHONE_PLANS_PATH]: {
		companyListHeaderParts: [
			"#",
			"Company",
			"Starting Price",
			"Unlimited Data Price",
			"Payment Options",
		],
		serviceRightColumns: [
			{ fields: "startingPrice", label: "Starting Price" },
			{ fields: "unlimitedDataPrice", label: "Unlimited Data Price" },
			{ fields: "paymentOptions", label: "Payment Options" },
		],
	},
	[INVISIBLE_BRACES_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[HAIR_GROWTH_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
		filteringInformation: {
			filterFunctions: {
				[HAIR_GROWTH_FILTERING_KEY]: filterByHairGrowthType,
			},
			defaultFilteringState: [
				{
					filteringKey: HAIR_GROWTH_FILTERING_KEY,
					filterValue: GENDER_MEN_HAIR_GROWTH_URL_PARAMETER,
				},
			],
			urlPathFilteringConfiguration: {
				[GENDER_WOMEN_HAIR_GROWTH_URL_PARAMETER]: [
					{
						filteringKey: HAIR_GROWTH_FILTERING_KEY,
						filterValue: GENDER_WOMEN_HAIR_GROWTH_URL_PARAMETER,
					},
				],
				[GENDER_MEN_HAIR_GROWTH_URL_PARAMETER]: [
					{
						filteringKey: HAIR_GROWTH_FILTERING_KEY,
						filterValue: GENDER_MEN_HAIR_GROWTH_URL_PARAMETER,
					},
				],
			},
		},
	},
	[TEETH_WHITENING_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[WEIGHT_LOSS_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
};
